var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DashboardOss'),_c('DashboardLkpm'),_c('DashboardSimbg'),_c('DashboardMppDigital'),_c('DashboardSicantik'),_c('DashboardSkmDpmptsp'),_c('DashboardSkmMpp'),_c('DashboardPengaduan')],1)}
var staticRenderFns = []

export { render, staticRenderFns }